<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';

    const page = usePage<SharedData>();

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        name: string;
    }>();

    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
</script>

<template>
    <div
        :key="`toolbar-actions-${props.name}-${selectedCompanyId}`"
        :class="cn('flex flex-wrap gap-4 lg:flex-nowrap sm:items-center', props.class)"
    >
        <slot />
    </div>
</template>
